import React, { Component } from "react";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import NewNavBar from "../../NavBar/Navbar";
import Sidebar from "../../Sidebar/sidebar";
import ResponsiveSidebar from "../../Sidebar/Responsive/SideBar";
import { Rendermastercomponent } from "./master";
import axios from "axios";
import addAccessTokenToUrl from "../../../Utils/Axios/addTokenToUrl";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import Navbar from "../../../../_components/common/Navbar";
export class Renderquestionnaire extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[0].id,
      sidebarOpen: false,
      defaultQuestionNumber: 1,
      value: null,
      values: {},
      assessmentModal: false,
      nestedModal: false,
      reviewMode: false,
      isPopOverVisible: false,
      overlayIsVisible: false,
      defaultColor: "#30c534",
      enableNotification: false,
      questionNumber: [],
      questionList: null,
      instrumentOptions: [],
      questionIndex: "",
      instrumentMultiRater: null,
      runningQuestionId: null,
      isMultiRater: "",
      uid: "",
      assessmentType: "",
      invitationDetails: null,
      participant_gender: "",
      participantId: "",
      multiraterStatus: "",
      min_batch_respondents: "",
    };
  }

  getQuestionsBasedOnInstrument({
    instrument,
    assessmentType,
    participant,
    user,
    completedQuestions,
    totalQuestions
  }) {
    /* questionnaire post api for fetching question data */
    axios
      .post(
        addAccessTokenToUrl(
          "/assessments/assessment/questions/based/on/instrument/"
        ),
        {
          instrument_id: instrument,
          is_participant: assessmentType === "assessment",
          user_id: participant,
          assessment_id: user,
        }
      )
      .then((response) => {
        try {
          const questionList = response.data.questions_list.find((q, i) => {
            return i == this.state.defaultQuestionNumber - 1;
          });

          const _values = {};
          for (let i = 0; i < response.data.questions_list.length; i++) {
            const question = response.data.questions_list[i];
            if (
              question.user_response &&
              question.user_response.assessment_value
            ) {
              _values[i + 1] = question.user_response.assessment_value;
            }
          }

          const getValueAccordingToCompletedCount = (completedQuestions, totalQuestions) => {
            if (completedQuestions === totalQuestions) {
              return _values[completedQuestions];
            }
            return questionList.user_response.assessment_value;
          }

          this.setState({
            questionList,
            questionNumber: response.data.questions_list,
            instrumentOptions: response.data.instument.instrument_options,
            runningQuestionId: questionList.id || 1,
            values: _values,
            value: getValueAccordingToCompletedCount(completedQuestions, totalQuestions)
          });
        } catch (error) {

          toast.error('You have already given this assessment.', {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 2000,
            onClose: () => {
              this.props.history.push('/new/app/dashboard');
            },
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  componentDidMount() {
    const instrument = this.props.match.params.instrument_id;
    const user = this.props.match.params.id;
    const participant = this.props.match.params.participant__id;
    const assessmentCompletedCount = this.props.match.params
      .assessmentCompletedCount;
    const assessmentType = this.props.match.params.assessmentType;
    const node = this.myRef.current;
    // const calcInnerWidth = node.offsetWidth;

    this.setState({
      // defaultQuestionNumber: parseInt(assessmentCompletedCount) + 1,
      uid: user,
      participantId: participant,
    });

    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        const instrumentMultiRater = response.data.user_assessments.find(
          (userId) => {
            return userId.id == user;
          }
        );
        const invitationDetails = response.data.my_inivation.find((i) => {
          return i.user_assessment__id == user;
        });
        if (assessmentType == "assessment") {
          const getQuestionIterator = (assessment_completed_count, assessment_number_count) => {
            if (assessment_completed_count < assessment_number_count) {
              return 1;
            }
            return 0;
          }
          this.setState({
            defaultQuestionNumber: parseInt(assessmentCompletedCount) + getQuestionIterator(instrumentMultiRater.assessment_completed_count, instrumentMultiRater.assessment_number_count),
            instrumentMultiRater,
            assessmentType,
            isMultiRater: instrumentMultiRater.instrument__is_multi_rater,
            min_batch_respondents: instrumentMultiRater.batch__min_respondent,
          });
        } else {
          const getInvitationQuestionIterator = (respondent_completed_count, user_assessment__assessment_number_count) => {
            if (respondent_completed_count < user_assessment__assessment_number_count) {
              return 1;
            }
            return 0;
          }
          this.setState({
            defaultQuestionNumber: parseInt(assessmentCompletedCount) + getInvitationQuestionIterator(invitationDetails.respondent_completed_count, invitationDetails.user_assessment__assessment_number_count),
            invitationDetails,
            participant_gender:
              invitationDetails.user_assessment__participant__gender,
            assessmentType,
          });
        }
        this.getQuestionsBasedOnInstrument({
          instrument,
          assessmentType,
          participant,
          user,
          completedQuestions: assessmentType == "assessment" ? instrumentMultiRater.assessment_completed_count : invitationDetails.respondent_completed_count,
          totalQuestions: assessmentType == "assessment" ? instrumentMultiRater.assessment_number_count : invitationDetails.user_assessment__assessment_number_count,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
  /* in component didUpdate we are comparing the current default question number with the previous default question number */
  componentDidUpdate(prevProps, prevState) {
    if (this.state.defaultQuestionNumber !== prevState.defaultQuestionNumber) {
      if (this.state.defaultQuestionNumber && Object.keys(this.state.values).length) {
        this.setState({
          value: this.state.values[this.state.defaultQuestionNumber],
        });
      }
    }
  }
  /* this function will handle the question number */
  handleQuestionNumber = (questions, questionNumber, questionIndex) => {
    const node = this.myRef.current;
    const calcInnerWidth = node ? node.offsetWidth : 0;
    this.setState({
      defaultQuestionNumber: questionIndex + 1,
      questionList: questions,
    });
    if (questionNumber === 15 || questionNumber === 30) {
      node.scrollTo({
        behavior: 'smooth',
        left: questionNumber === 15 ? calcInnerWidth / 2 : calcInnerWidth
      });
    }
  };
  /* this function will handle the next button we will have to call the question answer posting api here */
  handleGoToNext = () => {
    const user = this.props.match.params.id;
    const participant = this.props.match.params.participant__id;
    const userOrg = this.props.match.params.organisation;
    const userSeller = this.props.match.params.seller;
    const arrIndex = this.state.questionNumber.indexOf(this.state.questionList);
    const questionId = this.state.questionNumber[arrIndex].id;
    const assessmentType = this.props.match.params.assessmentType;

    /* questionnaire posting answer api for fetching question data */
    const assessmentApi = "/assessments/user/assessment/";
    const invitationsApi = "/assessments/user/respondent/assessment/";

    if (this.state.value === undefined || this.state.value === null) {
      return
    } else {

      let roundValue = Math.round(this.state.value) - 1;

      if (roundValue <= 0) {
        roundValue = 0;
      }
      if (roundValue >= 8) {
        roundValue = 8;
      }
      const setIntrumentOptions = this.state.instrumentOptions[roundValue].id;

      axios
        .post(
          addAccessTokenToUrl(
            assessmentType == "assessment" ? assessmentApi : invitationsApi
          ),
          {
            organisation: parseInt(userOrg),
            user_assessment: parseInt(user),
            assessment_option: setIntrumentOptions,
            user: participant,
            assessment_question: questionId.toString(),
            seller: parseInt(userSeller),
            assessment_value: this.state.value,
          }
        )
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.handleQuestionNumber(
              this.state.questionNumber[arrIndex + 1],
              +this.state.questionNumber[arrIndex + 1].question_number,
              arrIndex + 1
            );
          }

        })
        .catch((error) => {
          console.error(error);
        });
    }


  };

  handlePrevToNext = () => {
    const arrIndex = this.state.questionNumber.indexOf(this.state.questionList);
    if (arrIndex > 0) {
      this.handleQuestionNumber(
        this.state.questionNumber[arrIndex - 1],
        +this.state.questionNumber[arrIndex - 1].question_number,
        arrIndex - 1
      );
    }
  };


  handleSaveAndContinue = () => {
    const arrIndex = this.state.questionNumber.indexOf(this.state.questionList);
    this.handleGoToNext(
      this.state.questionNumber[arrIndex + 1],
      this.state.questionNumber[arrIndex + 1].id,
      arrIndex + 1
    );
  };
  /* this is the onchange handler for the rating slider */

  handleInputRange = (getInputRangeValue) => {
    this.setState({
      value: getInputRangeValue.toFixed(2),
      values: {
        ...this.state.values,
        [this.state.defaultQuestionNumber]: getInputRangeValue,
      },
      defaultColor: "#30c534",
    });
  };
  /* handle the questionnaire submit button */
  handleAssessmentSubmit = () => {
    if (this.state.defaultQuestionNumber === this.state.questionNumber.length) {
      const user = this.props.match.params.id;
      const participant = this.props.match.params.participant__id;
      const userOrg = this.props.match.params.organisation;
      const userSeller = this.props.match.params.seller;
      const arrIndex = this.state.questionNumber.indexOf(this.state.questionList);
      const questionId = this.state.questionNumber[arrIndex].id;
      const assessmentType = this.props.match.params.assessmentType;

      /* questionnaire posting answer api for fetching question data */
      const assessmentApi = "/assessments/user/assessment/";
      const invitationsApi = "/assessments/user/respondent/assessment/";
      let roundValue = Math.round(this.state.value) - 1;
      if (roundValue <= 0) {
        roundValue = 0;
      }
      if (roundValue >= 8) {
        roundValue = 8;
      }
      const setIntrumentOptions = this.state.instrumentOptions[roundValue].id;
      axios
        .post(
          addAccessTokenToUrl(
            assessmentType == "assessment" ? assessmentApi : invitationsApi
          ),
          {
            organisation: parseInt(userOrg),
            user_assessment: parseInt(user),
            assessment_option: setIntrumentOptions,
            user: participant,
            assessment_question: questionId.toString(),
            seller: parseInt(userSeller),
            assessment_value: this.state.value,
          }
        )
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.setState({
              assessmentModal: true,
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              autoClose: 2000,
              onClose: () => {
                this.props.history.push('/new/app/dashboard');
              },
            });
          } else {
            console.error(error);
          }
        });
    } else this.handleGoToNext();
  };


  handleModalClose = () => {
    this.setState({
      assessmentModal: false,
    });
  };
  handleModalSubmit = () => {
    const user = this.props.match.params.id;
    const participant = this.props.match.params.participant__id;
    const assessmentType = this.props.match.params.assessmentType;
    /* call questionnaire submit api here */
    const participantQuestionnaireSubmit =
      "/assessments/submit/user/assessments/";
    const invitationsQuestionnaireSubmit =
      "/assessments/submit/user/respondence/assessments/";
    axios
      .post(
        addAccessTokenToUrl(
          assessmentType == "assessment"
            ? participantQuestionnaireSubmit
            : invitationsQuestionnaireSubmit
        ),
        { user_assessment: user, user: participant }
      )
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          this.setState({
            nestedModal: true,
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  handleReviewAssessment = () => {
    this.setState({
      assessmentModal: false,
      reviewMode: true,
      defaultQuestionNumber: 1,
      questionList: this.state.questionNumber[0],
    });
    // this.handleInputRange(rangeValue);
  };
  handleReviewPopOver = () => {
    this.setState({
      isPopOverVisible: true,
      overlayIsVisible: true,
    });
  };
  handleReviewAssessmentSubmit = () => {
    this.setState({
      nestedModal: true,
    });
    this.handleModalSubmit();
  };
  handleCloseReviewPopOver = () => {
    this.setState({
      isPopOverVisible: false,
      overlayIsVisible: false,
    });
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }

  render() {
    const fullName = localStorage.getItem("full_name");
    const shortName = localStorage.getItem("short_name");
    const isAuthParticipant = localStorage.getItem("is_auth_participant");
    const assessment_done = localStorage.getItem("assessment_done");
    const userType = localStorage.getItem('usertype') || "";

    /* check if full name and short name exists if not then redirect them to create profile */
    if (isAuthParticipant === 'true' && assessment_done === 'true') {
      this.props.history.push({
        pathname: "/assessment-expired",
      });
    }
    const isNameEmpty = !fullName || fullName === "null";
    const isShortNameEmpty = !shortName || shortName === "null";

    if (isAuthParticipant === 'true' && (isNameEmpty || isShortNameEmpty)) {
      this.props.history.push("/new/app/createprofile");
    }

    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (
          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            handleCloseNotification={this.handleCloseNotification}
          />
        )}



        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Sidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            reviewMode={this.state.reviewMode}
          />
        ) : null}


        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        ) : null}

        <Rendermastercomponent
          defaultQuestionNumber={this.state.defaultQuestionNumber}
          handleQuestionNumber={this.handleQuestionNumber}
          value={this.state.value}
          handleInputRange={this.handleInputRange}
          handleGoToNext={this.handleGoToNext}
          handlePrevToNext={this.handlePrevToNext}
          handleAssessmentSubmit={this.handleAssessmentSubmit}
          assessmentModal={this.state.assessmentModal}
          handleModalClose={this.handleModalClose}
          handleModalSubmit={this.handleModalSubmit}
          nestedModal={this.state.nestedModal}
          values={this.state.values}
          reviewMode={this.state.reviewMode}
          handleReviewAssessment={this.handleReviewAssessment}
          isPopOverVisible={this.state.isPopOverVisible}
          overlayIsVisible={this.state.overlayIsVisible}
          handleReviewPopOver={this.handleReviewPopOver}
          handleCloseReviewPopOver={this.handleCloseReviewPopOver}
          handleReviewAssessmentSubmit={this.handleReviewAssessmentSubmit}
          handleSaveAndContinue={this.handleSaveAndContinue}
          touched={Boolean(this.state.values[this.state.defaultQuestionNumber])}
          defaultColor={this.state.defaultColor}
          questionNumber={this.state.questionNumber}
          questionList={this.state.questionList}
          instrumentOptions={this.state.instrumentOptions}
          myRef={this.myRef}
          instrumentType={
            this.state.assessmentType == "assessment"
              ? this.state.instrumentMultiRater &&
              this.state.instrumentMultiRater.instrument__instrument_name
              : this.state.invitationDetails &&
              this.state.invitationDetails
                .user_assessment__instrument__instrument_name
          }
          runningQuestionId={this.state.runningQuestionId}
          uid={this.state.uid}
          assessmentType={this.state.assessmentType}
          invitationDetails={this.state.invitationDetails}
          participant_gender={this.state.participant_gender}
          participantId={this.state.participantId}
          isMultiRater={this.state.isMultiRater}
          min_batch_respondents={this.state.min_batch_respondents}
        />
      </div>
    );
  }
}
export default withRouter(Renderquestionnaire);



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/index.jsx